import { useCallback } from 'react';
import Gift from '@/assets/icons/Gift.svg';
import { DiscountCardDisclosure } from '@/components/DiscountCardDisclosure';
import { useCheckout } from '@/contexts/checkoutContext';
import { useDataLayer } from '@/hooks/useDataLayer';
import { GiftCardForm } from './GiftCardForm';
import { StoredGiftCards } from './StoredGiftCards';
import { useGiftCards } from './useGiftCards';

export const GiftCards = () => {
  const { checkoutData } = useCheckout();
  const { addPaymentInfo } = useDataLayer();
  const { hasAppliedCards, hasStoredCards } = useGiftCards();

  const handleExpand = useCallback(() => {
    addPaymentInfo('Gift Card', checkoutData.items || []);
  }, [addPaymentInfo, checkoutData.items]);

  return (
    <DiscountCardDisclosure
      icon={<Gift />}
      isExpanded={hasAppliedCards}
      label="Gift card"
      onExpand={handleExpand}
    >
      {hasStoredCards ? <StoredGiftCards /> : <GiftCardForm />}
    </DiscountCardDisclosure>
  );
};
